import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Download, Printer, CreditCard } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { api } from '../App';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export default function MyCard() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => { api.get(`/api/members/card/${token}`).then(setInfo).catch(e => setError(e.message)); }, [token]);
  const front = `${BACKEND}/api/members/card/${token}/front`;
  const back = `${BACKEND}/api/members/card/${token}/back`;

  return (
    <div className="min-h-[70vh] bg-[hsl(var(--lux-ivory))] py-10 px-4" data-testid="my-card-page">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-6 print:hidden">
          <p className="text-xs tracking-[0.3em] uppercase text-[hsl(var(--lux-gold))]">Gujarat Samaj Nottingham</p>
          <h1 className="text-3xl font-bold text-[hsl(var(--lux-royal))]" style={{ fontFamily: 'Cormorant Garamond' }}>Your Digital Membership Card</h1>
        </div>
        {error && <Card className="border-red-700"><CardContent className="p-6 text-center text-red-800" data-testid="my-card-error">{error}</CardContent></Card>}
        {info && (
          <>
            <div className="flex items-center justify-center gap-3 mb-4 print:hidden">
              <Badge className="bg-[hsl(var(--lux-royal))] text-white">{info.membership_type}</Badge>
              <Badge variant="outline" className={info.live_status === 'ACTIVE' ? 'border-[hsl(var(--lux-gold))] text-[hsl(var(--lux-royal))]' : 'border-red-700 text-red-800'} data-testid="my-card-status">{info.live_status}</Badge>
              {info.expires_at && <span className="text-sm text-[hsl(var(--lux-ink)/0.7)]">Valid until {info.expires_at}</span>}
            </div>
            {info.has_card ? (
              <div className="space-y-5">
                <img src={front} alt="Membership card front" className="w-full rounded-2xl shadow-xl" data-testid="my-card-front" />
                <img src={back} alt="Membership card back" className="w-full rounded-2xl shadow-xl" data-testid="my-card-back" />
              </div>
            ) : (
              <Card><CardContent className="p-8 text-center" data-testid="my-card-pending"><CreditCard className="w-10 h-10 mx-auto text-[hsl(var(--lux-royal))]" /><p className="mt-3 font-medium">{info.live_status === 'PROVISIONAL' || info.live_status === 'ON_HOLD' ? 'Your membership is provisional — the verified card is issued once your ID has been checked.' : 'Your card is being prepared. Please check back shortly.'}</p><p className="text-sm text-[hsl(var(--lux-ink)/0.7)] mt-1">Membership number {info.membership_number} is already yours and is shown in your confirmation email.</p></CardContent></Card>
            )}
            <div className="mt-6 flex flex-wrap gap-3 justify-center print:hidden">
              <a href={front} download={`GS-membership-card-${info.membership_number}.png`}><Button className="bg-[hsl(var(--lux-royal))] text-white" data-testid="my-card-download"><Download className="w-4 h-4 mr-2" /> Save card image</Button></a>
              <Button variant="outline" onClick={() => window.print()} data-testid="my-card-print"><Printer className="w-4 h-4 mr-2" /> Print</Button>
              <Link to="/events"><Button variant="ghost">Browse events</Button></Link>
            </div>
            <p className="mt-6 text-center text-xs text-[hsl(var(--lux-ink)/0.55)] print:hidden">Keep this link private — it gives access to your card. Show the QR at events; staff verify it live against the membership register.</p>
          </>
        )}
      </div>
    </div>
  );
}
